export function containsIgnoreCase(str: string, searchStr: string): boolean {
  if (!str) {
    return false;
  }
  if (!searchStr) {
    return true;
  }
  return str.toLowerCase().includes(searchStr.toLowerCase());
}

export function stringToDate(str: string): Date | undefined {
  return str ? new Date(str) : undefined;
}
